module.exports = __webpack_public_path__ + "media/images/flags/16/Slovenia-fb915f85a954e556c22d2e8b4b638d27.png";